// extracted by mini-css-extract-plugin
module.exports = {"Container":"Tables_Container__2n8Hs","Header":"Tables_Header__8FbV0","Collection":"Tables_Collection__1L1EN"};